import React from 'react'
import styled from 'styled-components'
import { HEALTH_COLORS } from './healthUtils'

const LegendContainer = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  font-family: Roboto, Helvetica, sans-serif;
  font-size: 12px;
  min-width: 150px;
  z-index: 1000;
`

const LegendTitle = styled.div`
  font-weight: bold;
  margin-bottom: 8px;
  color: #333;
  font-size: 13px;
`

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  color: #555;
`

const LegendDot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${props => props.color};
  margin-right: 8px;
  border: 2px solid white;
  box-shadow: 0 0 4px rgba(0,0,0,0.3);
`

const MapLegend = () => {
  const legendItems = [
    { status: 'green', label: 'Healthy' },
    { status: 'yellow', label: 'Warning' },
    { status: 'red', label: 'Critical' },
    { status: 'gray', label: 'Offline' },
    { status: 'unknown', label: 'Unknown' }
  ]

  return (
    <LegendContainer>
      <LegendTitle>Modality Health Status</LegendTitle>
      {legendItems.map(item => (
        <LegendItem key={item.status}>
          <LegendDot color={HEALTH_COLORS[item.status]} />
          {item.label}
        </LegendItem>
      ))}
    </LegendContainer>
  )
}

export default MapLegend
